import {IReservationFlowEngine, IReservationFlowEngineContext, IReservationFlowRun} from "../types/IReservationFlowEngine";
import {isProfileNameFailure} from "./get_reservation_code_step_view";
import {createEmptyReservationDigits} from "./reservation_code_digits";
import {confirmReservation, initiateReservation, retryReservation, saveReservationName} from "./reservation_flow_calls";
import {isLocked} from "./reservation_time";

export const createReservationFlowRun = (): IReservationFlowRun => ({authRetriesUsed: 0});

const start = (ctx: IReservationFlowEngineContext) => {
    const {request} = ctx.latestRef.current;

    // only from idle - going back to the code step must not send another code
    if (request === null || ctx.transitions.applyCallStart({type: "START"}) === null) {
        return;
    }

    ctx.tracking.started(request);
    void initiateReservation(ctx, request, false);
};

const setDigits = (ctx: IReservationFlowEngineContext, digits: string[]) => {
    const current = ctx.stateRef.current;

    if (current.status === "code_entry" && !current.isExpired && !isLocked(current, Date.now())) {
        ctx.codeEntry.setDigits(digits);
    }
};

const submitCode = (ctx: IReservationFlowEngineContext, code: string) => {
    const {request} = ctx.latestRef.current;

    if (request === null) {
        return;
    }

    const next = ctx.transitions.applyCallStart({type: "CODE_SUBMIT", code, now: Date.now()});

    // refused (a second submit, an incomplete, expired or locked code) or expired on the way
    if (next?.status !== "confirming") {
        return;
    }

    ctx.tracking.codeSubmitted(request);
    void confirmReservation(ctx, request, next);
};

const resend = (ctx: IReservationFlowEngineContext) => {
    const {request} = ctx.latestRef.current;
    const previous = ctx.stateRef.current;

    if (request === null || previous.status !== "code_entry" || ctx.transitions.applyCallStart({type: "RESEND", now: Date.now()}) === null) {
        return;
    }

    ctx.tracking.resent(request, previous.codesSent);
    void initiateReservation(ctx, request, true);
};

// failed for the profile name: saves a valid name to the profile, then initiates again
const submitName = (ctx: IReservationFlowEngineContext, name: string) => {
    if (ctx.nameFormActions.isSaving() || !isProfileNameFailure(ctx.stateRef.current)) {
        return;
    }

    const nameToSave = ctx.nameFormActions.startSave(name);

    if (nameToSave !== null) {
        void saveReservationName(ctx, nameToSave, ctx.runRef.current);
    }
};

const reset = (ctx: IReservationFlowEngineContext) => {
    ctx.tracking.reset();
    ctx.runRef.current = createReservationFlowRun();
    ctx.codeEntry.setDigits(createEmptyReservationDigits());
    ctx.codeEntry.setIsNewCodeSent(false);
    ctx.nameFormActions.reset();
    ctx.transitions.apply({type: "RESET"});
};

export const createReservationFlowEngine = (ctx: IReservationFlowEngineContext): IReservationFlowEngine => ({
    start: () => start(ctx),
    setDigits: (digits) => setDigits(ctx, digits),
    submitCode: (code) => submitCode(ctx, code),
    resend: () => resend(ctx),
    retry: () => retryReservation(ctx),
    submitName: (name) => submitName(ctx, name),
    reset: () => reset(ctx),
    expireHandle: (handle) => {
        ctx.transitions.apply({type: "HANDLE_EXPIRED", handle});
    }
});
import {IReservationFlowEngine, IReservationFlowEngineContext, IReservationFlowRun} from "../types/IReservationFlowEngine";
import {isProfileNameFailure} from "./get_reservation_code_step_view";
import {createEmptyReservationDigits} from "./reservation_code_digits";
import {confirmReservation, initiateReservation, retryReservation, saveReservationName} from "./reservation_flow_calls";
import {isLocked} from "./reservation_time";

export const createReservationFlowRun = (): IReservationFlowRun => ({authRetriesUsed: 0});

const start = (ctx: IReservationFlowEngineContext) => {
    const {request} = ctx.latestRef.current;

    // only from idle - going back to the code step must not send another code
    if (request === null || ctx.transitions.applyCallStart({type: "START"}) === null) {
        return;
    }

    ctx.tracking.started(request);
    void initiateReservation(ctx, request, false);
};

const setDigits = (ctx: IReservationFlowEngineContext, digits: string[]) => {
    const current = ctx.stateRef.current;

    if (current.status === "code_entry" && !current.isExpired && !isLocked(current, Date.now())) {
        ctx.codeEntry.setDigits(digits);
    }
};

const submitCode = (ctx: IReservationFlowEngineContext, code: string) => {
    const {request} = ctx.latestRef.current;

    if (request === null) {
        return;
    }

    const next = ctx.transitions.applyCallStart({type: "CODE_SUBMIT", code, now: Date.now()});

    // refused (a second submit, an incomplete, expired or locked code) or expired on the way
    if (next?.status !== "confirming") {
        return;
    }

    ctx.tracking.codeSubmitted(request);
    void confirmReservation(ctx, request, next);
};

const resend = (ctx: IReservationFlowEngineContext) => {
    const {request} = ctx.latestRef.current;
    const previous = ctx.stateRef.current;

    if (request === null || previous.status !== "code_entry" || ctx.transitions.applyCallStart({type: "RESEND", now: Date.now()}) === null) {
        return;
    }

    ctx.tracking.resent(request, previous.codesSent);
    void initiateReservation(ctx, request, true);
};

// failed for the profile name: saves a valid name to the profile, then initiates again
const submitName = (ctx: IReservationFlowEngineContext, name: string) => {
    if (ctx.nameFormActions.isSaving() || !isProfileNameFailure(ctx.stateRef.current)) {
        return;
    }

    const nameToSave = ctx.nameFormActions.startSave(name);

    if (nameToSave !== null) {
        void saveReservationName(ctx, nameToSave, ctx.runRef.current);
    }
};

const reset = (ctx: IReservationFlowEngineContext) => {
    ctx.tracking.reset();
    ctx.runRef.current = createReservationFlowRun();
    ctx.codeEntry.setDigits(createEmptyReservationDigits());
    ctx.codeEntry.setIsNewCodeSent(false);
    ctx.nameFormActions.reset();
    ctx.transitions.apply({type: "RESET"});
};

export const createReservationFlowEngine = (ctx: IReservationFlowEngineContext): IReservationFlowEngine => ({
    start: () => start(ctx),
    setDigits: (digits) => setDigits(ctx, digits),
    submitCode: (code) => submitCode(ctx, code),
    resend: () => resend(ctx),
    retry: () => retryReservation(ctx),
    submitName: (name) => submitName(ctx, name),
    reset: () => reset(ctx),
    expireHandle: (handle) => {
        ctx.transitions.apply({type: "HANDLE_EXPIRED", handle});
    }
});
